import React from 'react';
import { motion } from '@/lib/motion';

const stats = [
  { value: '260', suffix: '+', label: 'TEAM MEMBERS' },
  { value: '18', suffix: '+', label: 'YEARS EXPERIENCE' },
  { value: '43', suffix: '', label: 'COUNTRIES SERVED' },
  { value: '90K', suffix: '', label: 'SQ.FT FACILITY' },
];

export const StatsSection = () => {
  return (
    <section className="py-12 md:py-16 bg-obsidian" data-testid="stats-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.4 }}
              className="text-center"
              data-testid={`stat-${index}`}
            >
              <p className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white">
                {stat.value}<span className="text-bronze">{stat.suffix}</span>
              </p>
              <p className="font-body text-[10px] md:text-xs text-white/40 mt-1 tracking-wider">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
